
import { env } from '@env';
import { HttpRequestData, httpUtil, PaginationResponse } from '@/framework';

export interface GetReportBookingByStaffRequest extends HttpRequestData {
    readonly query: {
        readonly salonId: number;
        readonly startDate: string;
        readonly endDate: string;
    }
}

export interface GetReportBookingByStaffItem  {
    readonly totalRevenueBooking: number;
    readonly totalQuantity: number;
    readonly staffName?: string;
    readonly avatar?: string;
    readonly staffId?: number;
    readonly salonId?: number;
    readonly salonBranchId?: number;
}

export const getReportBookingByStaff = httpUtil.createHttpRequestMeta<
    GetReportBookingByStaffRequest,
    PaginationResponse<GetReportBookingByStaffItem>
>({
    baseUrl: env.orgServer,
    path: '/bookings/by-staff',
    method: 'GET',
    authentication: 'bearer'
});
